<template>
  <TheSidebarMenuItem
    v-bind="$attrs"
    class="MenuItemSearch"
    @click="searchModal.open()"
  >
    <template #icon>
      <UIIcon name="search" />
    </template>
    <template #label>Search chats</template>
  </TheSidebarMenuItem>

  <ModalChatSearch v-bind="searchModal" @close="searchModal.close()" />
</template>

<script setup lang="ts">
import { UIIcon } from '@foundever/ui-lib'

import { useModal } from '@/composables/useModal'
import ModalChatSearch from '@/views/components/modals/ModalChatSearch.vue'

import TheSidebarMenuItem from '../TheSidebarMenuItem.vue'

defineOptions({
  inheritAttrs: false,
})

const searchModal = useModal()
</script>
